module.exports = __webpack_public_path__ + "img/gitHub.76d344f0.svg";